<template>
  <div class="wrapper">
    <div class="flex col7-of-12--large-up">
      <div class="handle-wrapper">
        <svg
          class="handle"
          width="18"
          height="8"
          viewBox="0 0 18 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.625 2.375C17.7188 2.375 17.8125 2.34375 17.875 2.28125C17.9375 2.21875 18 2.125 18 2V1C18 0.90625 17.9375 0.8125 17.875 0.75C17.8125 0.6875 17.7188 0.625 17.625 0.625H0.375C0.25 0.625 0.15625 0.6875 0.09375 0.75C0.03125 0.8125 0 0.90625 0 1V2C0 2.125 0.03125 2.21875 0.09375 2.28125C0.15625 2.34375 0.25 2.375 0.375 2.375H17.625ZM17.625 7.375C17.7188 7.375 17.8125 7.34375 17.875 7.28125C17.9375 7.21875 18 7.125 18 7V6C18 5.90625 17.9375 5.8125 17.875 5.75C17.8125 5.6875 17.7188 5.625 17.625 5.625H0.375C0.25 5.625 0.15625 5.6875 0.09375 5.75C0.03125 5.8125 0 5.90625 0 6V7C0 7.125 0.03125 7.21875 0.09375 7.28125C0.15625 7.34375 0.25 7.375 0.375 7.375H17.625Z"
            fill="#AEB5C1"
          />
        </svg>
      </div>
      <div class="left">
        <Input
          style="width: 100%;"
          :value="value"
          @input-change="handleEdit({ ...data, ...$event })"
          :required="true"
          :placeholder="placeholder"
          name="name"
        />
      </div>
    </div>
    <div class="right">
      <div
        @click="$emit('delete-click')"
        style="padding: 0.5rem; cursor: pointer;"
      >
        <svg
          class="delete-button"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="#D82C0D"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.5 5L9.84375 8.375C9.9375 8.46875 10 8.59375 10 8.71875C10 8.875 9.9375 9 9.84375 9.0625L9.0625 9.84375C8.96875 9.96875 8.84375 10 8.71875 10C8.5625 10 8.4375 9.96875 8.375 9.84375L5 6.5L1.625 9.84375C1.53125 9.96875 1.40625 10 1.28125 10C1.125 10 1 9.96875 0.9375 9.84375L0.15625 9.0625C0.03125 9 0 8.875 0 8.71875C0 8.59375 0.03125 8.46875 0.15625 8.375L3.5 5L0.15625 1.625C0.03125 1.5625 0 1.4375 0 1.28125C0 1.15625 0.03125 1.03125 0.15625 0.9375L0.9375 0.15625C1 0.0625 1.125 0 1.28125 0C1.40625 0 1.53125 0.0625 1.625 0.15625L5 3.5L8.375 0.15625C8.4375 0.0625 8.5625 0 8.71875 0C8.84375 0 8.96875 0.0625 9.0625 0.15625L9.84375 0.9375C9.9375 1.03125 10 1.15625 10 1.28125C10 1.4375 9.9375 1.5625 9.84375 1.625L6.5 5Z"
            fill="#FF5252"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/DesignSystem/Input';
export default {
  components: { Input },
  props: {
    data: Object,
    value: String,
    placeholder: String,
  },
  methods: {
    handleEdit(payload) {
      const data = {
        ...payload,
        [payload.key]: payload.value,
      };
      this.$emit('update-input', data);
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 0;
  background-color: #fff;
  border-radius: 5px;
  border: 1px solid #dadee6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.left {
  width: 100%;
  padding: 0.375rem 0;
}

.right {
  padding: 0 1rem;
}

.left,
.right {
  display: flex;
  align-items: center;
}

.handle-wrapper {
  align-self: stretch;
  height: auto;
  display: flex;
  align-items: center;

  .handle {
    cursor: pointer;
    min-width: 18px;
    margin-left: 1rem;
    margin-right: 1rem;
  }
}
.delete-button {
  height: 12px;
  width: 12px;
  margin-right: 6px;
  cursor: pointer;
}
</style>
